import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../Styles";
import ExecutiveSummary from "./Summary";
import CompanyIdentification from "./CompanyIdentification";
import ContactInformation from "./ContactInformation";
import DateUtils from "src/services/utils/DateUtils";
import CorporateStructure from "./CorporateStructure";
import Appendices from "./Appendices";
import CorporateLinkages from "./CorporateLinkages";
import FinancialOverview from "./FinancialOverview";
import { INTERNATIONAL_MOMENT_DATE_FORMAT } from "src/components/constants";

const Sections = (props) => {
  const { supplierData, noteBackgroundColor, detailsQuery } = props;
  const { company, financial_summary, management_team, company_shareholders } =
    detailsQuery;
  const dateUtils = new DateUtils();
  const currencyLocal = financial_summary?.currency ?? "EUR";

  const convertApiDate = (dateStr) => {
    return dateUtils.convertDateToDate(dateStr, INTERNATIONAL_MOMENT_DATE_FORMAT);
  };

  const money = (amount, currency) =>
    amount
      ? Intl.NumberFormat("en-US", {
          style: "currency",
          currency,
          maximumFractionDigits: 2,
        }).format(Number(amount))
      : "-";

  const statementDate = financial_summary?.statementDate
    ? convertApiDate(financial_summary.statementDate)
    : "-";

  const statementYear = financial_summary?.statementDate
    ? String(financial_summary.statementDate).slice(0, 4)
    : null;

  styles.sectionSeparator.backgroundColor = noteBackgroundColor;

  return (
    <View>
      <ExecutiveSummary
        company={company}
        company_shareholders={company_shareholders}
        financial_summary={financial_summary}
        statementYear={statementYear}
        currencyLocal={currencyLocal}
        money={money}
        convertApiDate={convertApiDate}
      />

      <CompanyIdentification company={company} />

      <ContactInformation company={company} />

      <CorporateStructure
        company={company}
        financial_summary={financial_summary}
        management_team={management_team}
      />

      <FinancialOverview
        financial_summary={financial_summary}
        money={money}
        currencyLocal={currencyLocal}
        statementDate={statementDate}
      />

      <CorporateLinkages
        company={company}
        company_shareholders={company_shareholders}
      />

      <Appendices
        company={company}
        company_shareholders={company_shareholders}
        management_team={management_team}
      />
    </View>
  );
};

export default withNamespaces()(Sections);
